import FullscreenDecorator from '../lib/FullscreenDecorator.js';
import ConfirmDialog from '../lib/ConfirmDialog.js';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', '$controllerator', 'radio'],
    callable(ele, controllerator, radio) {
        const latEle = ele.querySelector("[name='lat']");
        const lonEle = ele.querySelector("[name='lon']");
        const inputEle = ele.querySelector('[data-geo-center]');

        radio('geo-map-clicked').subscribe(showFullscreenDialog);

        // Opening on touchend is faster than focusing the input and then opening, because
        // we can skip at least one layout in the middle of opening the modal.
        // In theory we could use focusin, but that fires after focus in most browsers :(
        inputEle.addEventListener('touchstart', event => {
            // FIXME: in iOS 10 we have to run preventDefault(), otherwise the input doesn't get focused.
            // This might be a bug. In some Android versions, we can't runt preventDefault(), because
            // the overlay doesn't open at all. Should try to solve this without special-casing iOS.
            if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                event.preventDefault();
            }
            inputEle.addEventListener('touchend', handle);
            inputEle.addEventListener('touchmove', reset);
        });

        function handle(event) {
            event.stopPropagation();
            event.preventDefault();
            showFullscreenDialog(true);
        }

        function reset() {
            inputEle.removeEventListener('touchend', handle);
            inputEle.removeEventListener('touchmove', reset);
        }

        // The focus event is sometimes triggered by autofocus even if this is done on
        // DOMContentLoaded (bug?). setTimeout() prevents this from happening.
        window.setTimeout(() => {
            inputEle.addEventListener('focus', () =>
                showFullscreenDialog(true)
            );
        });

        function showFullscreenDialog(shouldFocus) {
            const contentEle = createDialogContent();

            const options = {
                size: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                },
                onHideFocusElement: ele.querySelector('[data-focus]'),
                onDismiss(reason) {
                    radio('geo-widget-fullscreen-dismissed').broadcast();

                    if (reason === ConfirmDialog.POSITIVE_LABEL) {
                        const latEle = contentEle.querySelector("[name='lat']");
                        const lonEle = contentEle.querySelector("[name='lon']");
                        const geoCenterInput =
                            contentEle.querySelector('[data-geo-center]') || '';

                        if (!geoCenterInput.value) {
                            latEle.value = '';
                            lonEle.value = '';
                        }

                        radio(
                            'geo-position-changed-from-fullscreen-search'
                        ).broadcast(
                            latEle.value,
                            lonEle.value,
                            geoCenterInput.value
                        );
                    }
                },
            };

            const FullscreenConfirmDialog = FullscreenDecorator(ConfirmDialog);

            const dialog = new FullscreenConfirmDialog(
                'I nærheten',
                contentEle,
                'Velg',
                'Avbryt',
                options
            );
            dialog.show();

            // Remove modal overlay bottom padding
            if (contentEle.parentNode) {
                contentEle.parentNode.classList.add('pbn');
            }

            removeFullscreenController(contentEle);
            controllerator.run();

            if (shouldFocus) {
                contentEle.querySelector('[name="geoLocationName"]').focus();
            }
        }

        function createDialogContent() {
            const contentEle = ele.cloneNode(true);
            contentEle.classList.remove('r-margin', 'mts');
            contentEle.setAttribute('data-fullscreen', 'true');

            const searchEle = contentEle.querySelector('[data-geo-search]');

            const inputEle = contentEle.querySelector('[data-geo-center]');
            inputEle.selectionStart = inputEle.value.length;

            const mapEle = el('div', {
                'data-controller': 'geoMap',
                'data-fullscreen': 'true',
                'data-latitude': latEle.value,
                'data-longitude': lonEle.value,
                style:
                    'flex: 1 100%; height: 100%; background-color: #B3D0B2; touch-action: initial;',
            });

            // Rearrange so that flex works properly
            contentEle.append(
                el(
                    'div.flex.column',
                    { style: 'height: 100%' },
                    el('div.r-margin', null, searchEle),
                    mapEle
                )
            );

            contentEle.removeChild(
                contentEle.querySelector('[data-geo-radius]')
            );
            contentEle.removeChild(contentEle.querySelector('[data-geo-map]'));
            contentEle
                .querySelector('[data-geo-search-wrapper]')
                .classList.add('hidden');
            contentEle.style.height = '100%';

            return contentEle;
        }

        function removeFullscreenController(ele) {
            let value = ele.getAttribute('data-controller');
            value = value.replace(/\bfullscreenMapSearch\b/, '');
            ele.setAttribute('data-controller', value);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/fullscreenMapSearch.js